const state = {
  status: "",
  Clubtoken: localStorage.getItem("token") || "",
  club: {},
  clubmenu: null,
  club_qrcode: null,
  loading: false
};

export default state;
